import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { ProductRepository } from "../../../../data/repository/product/ProductRepository";
import {  Message } from "../../../model/Auth";
import { Category } from "../../../model/Category";
import { Product } from "../../../model/Product";
import { ResponseState, State } from "../../../model/ResponseState";

export interface CreateProductUseCase {
  invoke: (product: Product) => Promise<ResponseState<Message>>;
}

export class CreateProductUseCaseImpl implements CreateProductUseCase {
  private repo: ProductRepository;

  constructor(repo: ProductRepository) {
    this.repo = repo;
  }

  async invoke(product: Product): Promise<ResponseState<Message>> {
    try {
      let response = await this.repo.create(product);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
